export default __webpack_public_path__ + "static/Petauri_KinectMax_logoCombo-e67285fd2abc180ca89f9a694169c11b.png";